/*
 * @format
 *
 * Reducer to capture the last completed commands from the API/device
 *
 */

import * as actionTypes from '../action-types';

/*
const example = {

  'home123': {
    'zone123': {
      last: {
        requestId: 'request1234',
        command: 'setPrtHoliday',
      }
    }
  },

  requests: {
    'request1234': {
      homeId: 'home123'
      zoneId: 'zone123'
    }
  }
};
*/

export const initalState = {
  requests: {},
};

export const completedMessages = (state = initalState, action) => {
  switch (action.type) {
    case actionTypes.COMMAND_SENT: {
      return {
        ...state,
        requests: {
          ...state.requests,
          [action.message.data.requestId]: {
            homeId: action.message.data.siId,
            zoneId: action.message.data.prtId,
            endpointId: action.message.data.endpointId,
          },
        },
      };
    }

    case actionTypes.COMMAND_COMPLETED: {
      const request = state.requests[action.message.requestId];

      if (!request) {
        return state;
      }

      return {
        ...state,
        [request.homeId]: {
          [request.zoneId]: {
            [request.endpointId]: {
              last: action.message,
            },
          },
        },
        requests: {
          ...state.requests,
          [action.message.requestId]: undefined,
        },
      };
    }

    case actionTypes.CLEAR_LAST_COMPLETED_COMMAND: {
      const { siId, prtId, endpointId } = action.message.data;

      return {
        ...state,
        [siId]: {
          [prtId]: {
            [endpointId]: {
              last: undefined,
            },
          },
        },
      };
    }

    case actionTypes.PENDING_CHANGE_TIMED_OUT: {
      return {
        ...state,
        requests: {
          ...state.requests,
          [action.requestId]: undefined,
        },
      };
    }

    default: {
      return state;
    }
  }
};
